module.exports = __webpack_public_path__ + "static/media/Gilroy-Light.4b236c6c.ttf";